/*
 * @Author: liujunhong
 * @Date: 2023/7/3
 * @Desc: home
 */

import React, { useEffect, useState } from 'react';
import GyyxBaseLib from 'gyyx-base-lib';
import Slider from 'react-slick';
import './index.less';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Nav, { KF_URL } from '@/components/Nav';
import { NavLink } from 'react-router-dom';


const settings = {
  dots: true,
  infinite: true,
  arrows: false,
  draggable: false,
  slidesToScroll: 1,
  slidesToShow: 1,
  autoplay: true,
};

const TEXT_URL = '//scgg.gyyx.cn/AdDataCommunity/gyyxBanner.txt';
const WX_URL = '//img.gyyxcdn.cn/www/Content/game/images/wdewm01.jpg';


interface BannerList {
  image: string;
  title: string;
  url: string;
}

const Index = () => {
  const [bannerList, setBannerList] = useState<BannerList[]>([]);

  useEffect(() => {
    GyyxBaseLib.loadJs({
      src: TEXT_URL, cb: () => {
        const res = (window as any).bannerData;
        res && setBannerList(res.data);
      },
    });
  }, []);

  return <div className="we_home_wrap">
    <Nav/>
    {0 < bannerList.length && <div className="we_banner_wrap">
      <Slider {...settings} >
        {bannerList.map(item => <div key={item.title}>
          <a href={item.url} target="_blank">
            <img src={item.image} alt={item.title}/>
          </a>
        </div>)}
      </Slider>
    </div>}
    <div className="we_footer_wrap">
      <div className="scan_wrap">

        <div className="scan_item">
          <img src={WX_URL} alt="问道"/>
          <div className="scan_info">
            <p>微信扫一扫</p>
            <p>获取最新游戏资讯</p>
            <p>公众号：gyyxwd</p>
          </div>
        </div>
        <div className="scan_item">
          <img src="//img.gyyxcdn.cn/kf/images/gyewm02.png" alt=""/>
          <div className="scan_info">
            <p>扫一扫</p>
            <p>下载光宇游戏App</p>
            <p>进入官网</p>
          </div>
        </div>
      </div>
      <div className="link_wrap">
        <ul className="link_group">
          <li className="title title_0">
            <i></i>
            <span>我要充值</span>
          </li>
          <li>
            <NavLink to="/wegame_pay">我要充值 </NavLink>
          </li>
        </ul>
        <ul className="link_group">
          <li className="title title_1">
            <i></i>
            <span>账号中心</span>
          </li>
          <li><NavLink to="/original_phone">更换绑定APP </NavLink></li>
          <li><NavLink to="/closure_info">游戏自助封停 </NavLink></li>
          <li><NavLink to="/unlock_info">游戏自助解封 </NavLink></li>
        </ul>
        <ul className="link_group">
          <li className="title title_2">
            <i></i>
            <span>客服中心</span>
          </li>
          <li><a href={KF_URL.stolenAndRecovered}>游戏物品被盗找回 </a></li>
          <li><a href={KF_URL.transactionAppeal}>奇宝斋物品交易申诉 </a></li>
          <li><a href={KF_URL.gameUnblock}>游戏解封申请 </a></li>
          <li><a href={KF_URL.serviceTracker}>服务跟踪 </a></li>
        </ul>

      </div>

    </div>
  </div>;
};
export default Index;
